export default __webpack_public_path__ + "static/deer-246c3f05f72b3dd9437904ffecf90c11.png";